/* global document, sessionStorage */
import commonConfig from "../../common/config";
import { getQueryParams } from "../../common/util/QueryParams";

let uiSettings = {};

export function setUISettings(settings) {
    uiSettings = {...uiSettings, ...settings};
}

export function getUISettings() {
    return uiSettings;
}

export function collectUISettings() {
    let args = getQueryParams(document.location.search);
    // Reset settings
    uiSettings = {};
    if (args['hideMenu']) {
        uiSettings.hideMenu = true;
    }
    if (args['hideNaviPath']) {
        uiSettings.hideNaviPath = true;
    }
    if (args['hideDeleteButton']) {
        uiSettings.hideDeleteButton = true;
    }
    if (args['hideScenarios']) {
        uiSettings.hideScenarios = true;
    }
    if (args['hideRelatedFlows']) {
        uiSettings.hideRelatedFlows = true;
    }
    if (args['hideOrganisationSettings']) {
        uiSettings.hideOrganisationSettings = true;
    }
    if (args['isUpgatesAddon']) {
        uiSettings.hideMenu = true;
        uiSettings.hideDeleteButton = true;
        uiSettings.hideScenarios = true;
        uiSettings.hideRelatedFlows = true;
        uiSettings.hideOrganisationSettings = true;
        uiSettings.isUpgatesAddon = true;
        uiSettings.channelDefId = commonConfig.CHANNEL_DEF_UPGATES;
        uiSettings.token = args['token'];
        uiSettings.addonType = "upgates";

        if (args['erp']) {
            sessionStorage.setItem('addonErp', args['erp']);
            uiSettings.erp = args['erp'];
        } else {
            uiSettings.erp = sessionStorage.getItem('addonErp');
        }

        sessionStorage.setItem('addonType', "upgates");

        // Try to get ID from URL
        const matchesChannel = document.location.pathname.match(/\/channels\/([^\/]+)/);
        const matchesOrganisation = document.location.pathname.match(/\/organisations\/([^\/]+)/);

        if (matchesChannel && matchesOrganisation) {
            // If we have ID in URL, save it to localStorage
            const channelId = matchesChannel[1];
            const organisationId = matchesOrganisation[1];

            if (channelId !== 'null' && organisationId !== 'null') {
                sessionStorage.setItem('addonChannelId', channelId);
                sessionStorage.setItem('addonOrganisationId', organisationId);
            }

            uiSettings.channelId = channelId;
            uiSettings.organisationId = organisationId;
        } else {
            // If we don't have ID in URL, use stored values
            uiSettings.channelId = sessionStorage.getItem('addonChannelId');
            uiSettings.organisationId = sessionStorage.getItem('addonOrganisationId');
        }
    }
    if (args['isShoptetAddon']) {
        uiSettings.isShoptetAddon = true;
        // TODO: Implement Shoptet addon
    }
}
